var _path, _g, _g2, _g3, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRetirementGoal(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 160 140",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#999999",
    d: "M136.3,105.44c0.32-1.37,0.51-2.76,0.51-4.17c0-0.12,0-0.25,0-0.37v-0.25c-0.12-6.18-3.09-12.37-9.65-17.32v0.12c-1.11-0.99-2.47-1.86-3.96-2.72l-0.3-2.27l-3.29,0.04c-9.28-3.71-23.38-6.31-38.09-6.31c-24.84,0-44.92,6.85-49.48,16.04l-0.98,4.11l-7.79-5.56c0.12,0,3.96,0.87,3.96,8.29c0,2.35,0.37,4.45,0.87,6.43c0.12,2.23,0.49,4.33,1.36,6.43c1.86,16.7,25.48,28.94,54.17,28.94c32.16,0,50.21-13.8,56.71-26.23L136.3,105.44z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#666666",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    d: "M45.78,90c-1.36,4.82-0.87,9.03,1.73,12.49c0.87,1.11,1.98,2.23,3.34,3.22"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#666666",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    d: "M53.82,93.46c0,6.56,8.53,11.63,20.78,13.36c1.61,0.25,7.42,0.49,8.91,0.49c5.81,0,11.13-0.74,15.58-1.98c11.63-2.1,21.64-5.94,23.99-10.76c0.74-1.48,0.99-3.09,0.37-4.58l0,0c0-0.12-0.12-0.12-0.12-0.25c-0.12-0.37-0.37-0.74-0.62-1.11c-1.86-2.35-2.35-4.45-1.61-5.94"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#666666",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    d: "M109.48,100.39c2.47-1.98,3.96-4.45,3.96-6.93"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#666666",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    d: "M111.83,86.04c2.72,0.62,6.93,2.23,8.91,4.33"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M133.84,78.87c0,0.12-1.24,2.1-5.81,0.12c-3.22-1.36-6.8-0.74-8.66,1.61"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000000",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M35.76,117.21c9.52,9.15,26.84,15.38,46.75,15.38c29.93,0,54.3-14.14,54.3-31.21c0-0.12,0-0.25,0-0.37v-0.25l0,0c-0.12-6.18-3.09-12.37-9.65-17.32v0.12c-1.11-0.99-2.47-1.86-3.96-2.72"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000000",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M23.27,86.91c0.12,0,3.96,0.87,3.96,8.29c0,2.35,0.37,4.45,0.87,6.43c0.12,2.23,0.49,4.33,1.36,6.43C31.31,124.76,54.93,137,83.63,137c32.16,0,54.79-15.46,58.13-30.55"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#666666",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    d: "M65.94,121.79c-25.73-5.32-36.12-12.99-36.12-26.47"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#666666",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    d: "M124.32,117.66c-9.4,6.93-24.74,11.5-41.8,11.5c-22.63,0-41.93-7.13-49.1-18.51"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#666666",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    d: "M134.46,101.26c-0.12,12.49-24.24,23-51.45,23"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#666666",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    d: "M84.24,118.32c25.97,0,47-9.89,47.25-22.51c0.37-0.99,0.62-2.1,0.62-3.09"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000000",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M119.62,78.62c-9.28-3.71-23.38-6.31-38.09-6.31c-28.32,0-50.46,8.91-50.46,20.04c0,11.26,22.14,20.04,50.46,20.04c20.16,0,37.35-4.45,45.52-11.13"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#666666",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    d: "M51.84,80.85c-10.64,3.46-15.71,8.04-15.71,14.72c0,0.99,0.25,1.98,0.62,3.09"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#d1f0ff",
    d: "M108.57,80.86c0-7.26-2.98-17.09-7.59-25.06c-5.17-8.93-11.55-14.04-17.51-14.04c-5.96,0-12.34,5.12-17.51,14.04c-4.61,7.96-7.59,17.8-7.59,25.06c0,10.2,6.12,18.99,14.87,22.91c3,0.47,6.39,0.76,10.23,0.76c3.83,0,7.22-0.29,10.23-0.76C102.45,99.85,108.57,91.06,108.57,80.86z M72.96,53.17c-5.01,6.27-9.1,15.68-10.68,24.57c-0.09,0.48-0.51,0.83-0.98,0.83c-0.06,0-0.12,0-0.18-0.02c-0.54-0.1-0.91-0.62-0.81-1.16c1.63-9.19,5.88-18.95,11.09-25.46c0.35-0.43,0.97-0.5,1.41-0.16C73.23,52.11,73.3,52.74,72.96,53.17z M80.92,46.38c-1.33,0.64-2.66,1.52-3.95,2.61c-0.19,0.16-0.42,0.24-0.64,0.24c-0.28,0-0.57-0.12-0.77-0.36c-0.36-0.42-0.3-1.05,0.12-1.41c1.42-1.2,2.89-2.17,4.37-2.88c0.5-0.24,1.1-0.03,1.34,0.46C81.63,45.54,81.42,46.14,80.92,46.38z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00adef",
    d: "M83.47,38.76c-16.23,0-28.1,27.69-28.1,42.1c0,8.19,3.52,15.57,9.13,20.71c2.44,0.88,5.33,1.66,8.74,2.2c-8.75-3.92-14.87-12.71-14.87-22.91c0-7.26,2.98-17.09,7.59-25.06c5.17-8.93,11.55-14.04,17.51-14.04c5.96,0,12.34,5.12,17.51,14.04c4.61,7.96,7.59,17.8,7.59,25.06c0,10.2-6.12,18.99-14.87,22.91c3.41-0.54,6.3-1.32,8.74-2.2c5.61-5.14,9.13-12.52,9.13-20.71C111.57,66.45,99.7,38.76,83.47,38.76z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00adef",
    d: "M80.05,44.58c-1.48,0.72-2.94,1.69-4.37,2.88c-0.42,0.36-0.48,0.99-0.12,1.41c0.2,0.23,0.48,0.36,0.77,0.36c0.23,0,0.46-0.08,0.64-0.24c1.3-1.09,2.62-1.97,3.95-2.61c0.5-0.24,0.7-0.84,0.46-1.34C81.15,44.55,80.55,44.34,80.05,44.58z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00adef",
    d: "M71.39,51.93c-5.21,6.51-9.45,16.27-11.09,25.46c-0.1,0.54,0.27,1.06,0.81,1.16c0.06,0.01,0.12,0.02,0.18,0.02c0.48,0,0.9-0.34,0.98-0.83c1.58-8.89,5.67-18.3,10.68-24.57c0.34-0.43,0.27-1.06-0.16-1.41C72.37,51.42,71.74,51.49,71.39,51.93z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#00AAFF",
    strokeMiterlimit: 10,
    strokeDasharray: "4,1,2,1",
    x1: 64.51,
    y1: 38.84,
    x2: 49.88,
    y2: 13.8
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#00AAFF",
    strokeMiterlimit: 10,
    strokeDasharray: "4,1,2,1",
    x1: 109.88,
    y1: 47.77,
    x2: 125,
    y2: 29.76
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#00AAFF",
    strokeMiterlimit: 10,
    strokeDasharray: "4,1,2,1",
    x1: 93.6,
    y1: 36.41,
    x2: 101.6,
    y2: 2
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#00AAFF",
    strokeMiterlimit: 10,
    strokeDasharray: "4,1,2,1",
    x1: 77.2,
    y1: 29.82,
    x2: 72.41,
    y2: 3.52
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#00AAFF",
    strokeMiterlimit: 10,
    strokeDasharray: "4,1,2,1",
    x1: 53.88,
    y1: 50.79,
    x2: 42.01,
    y2: 45.27
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#666666",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    d: "M58.18,95.13c0,0,3.79,9.42,25.24,9.42s25.24-9.42,25.24-9.42"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRetirementGoal);
export default __webpack_public_path__ + "static/media/retirement-goal.6a0621cf.svg";
export { ForwardRef as ReactComponent };